var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"name"},[(_vm.isRequired)?_c('span',{staticClass:"is-required"},[_vm._v("*")]):_vm._e(),_vm._v(_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }